import { Component, Input } from '@angular/core';
import { MessageService } from 'primeng/api';

@Component({
    selector: 'partner-mart-locations-active-services',
    templateUrl: './partner-mart-locations-active-services.component.html',
    styleUrls: ['./partner-mart-locations-active-services.component.scss'],
    providers: [MessageService]
})
export class PartnerMartLocationsActiveServicesComponent {
    @Input()
    public storeId: number = 0;

    constructor(private messageService: MessageService) {
    }
}
